module.exports = __webpack_public_path__ + "img/code_1.68d23566.jpg";